import { render, staticRenderFns } from "./bold3.vue?vue&type=template&id=3eb7e4e0&scoped=true&"
import script from "./bold3.vue?vue&type=script&lang=js&"
export * from "./bold3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb7e4e0",
  null
  
)

export default component.exports